<template>
  <section class="container mx-auto py-6 md:pt-15 md:pb-15 md:w-full">
    <h2 class="section-heading">Podcast</h2>

    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-8 md:gap-y-12 py-8 md:py-10"
    >
      <template v-if="isLoading">
        <div v-for="i in 4" :key="i" class="flex flex-col gap-4">
          <UtilsSkeletonLoading class="h-44" />
          <UtilsSkeletonLoading class="h-10" />
        </div>
      </template>
      <template v-else>
        <CommonPodcastCard
          v-for="item in contentsData"
          :key="item.id"
          :data="item"
        />
      </template>
    </div>

    <div class="mx-auto text-center">
      <CommonViewAllButton url="/podcasts" page-name="Podcast" />
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)
const contentsData = ref([])

const podcasts = await useSuitmediaApiData(`/api/contents`, {
  query: {
    'pagination[pageSize]': 8,
    populate: 'image,layout_component,layout_component.type',
    'filters[$and][0][layout][$eq]': 'podcast',
    sort: 'publish_at:desc'
  }
})

isLoading.value = podcasts.pending.value

if (podcasts.error.value) {
  throw createError({
    statusCode: 404,
    message: `Podcasts does not exist`
  })
}

contentsData.value = podcasts.data.value.data
</script>

<style lang="scss" scoped></style>
